import { UnleashFeatureToggleMenu } from 'config/unleash/unleash-feature-toggle-flag';
import React from 'react';
import { useShareholderGetAllByPersonIdState } from 'reducer/hooks';
import useFeatureFlagAvailabilityUtil from 'shared/util/feature-flag-utils';
import MenuItem, { MenuItemPropsList } from '../menu-item/menu-item';

const I18N_PREFIX = 'header.navbar';

const EntitiesMenu = () => {
    const baseUrl = '/investor';

    const { shareholders } = useShareholderGetAllByPersonIdState();

    const isFeatureFlagEnabled: boolean = useFeatureFlagAvailabilityUtil(UnleashFeatureToggleMenu.SHAREHOLDER_DOCUMENTS);

    const entities: MenuItemPropsList[] = [
        {
            translation: `${I18N_PREFIX}.wallet`,
            link: `${baseUrl}/wallet`,
            visibility: true
        },
        {
            translation: `${I18N_PREFIX}.shareholder-documents`,
            link: `${baseUrl}/shareholder-documents`,
            visibility: !!shareholders?.length && isFeatureFlagEnabled
        }
    ];

    return <MenuItem list={entities} menu={false} />;
};

export default EntitiesMenu;
